import { enumSchema } from '@shared/utils/enum.utils';

import { PriceFactorType } from '../enums/price-factor-type.enum';

export interface PriceFactor {
  id: string;
  order: number;
  name: string;
  type: PriceFactorType;
  factor: number;
  readonly: boolean;
  lastModifiedById: string;
  lastModified: Date;
}

export const priceFactorChatbotFields = {
  id: { type: 'string', description: 'Must be specified for update or delete.' },
  name: {
    type: 'string',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  type: enumSchema(
    'PriceFactorType',
    PriceFactorType,
    'Must be specified for new entries. Otherwise should be only set if the intend it to change it.'
  ),
  factor: {
    type: 'number',
    description: 'Must be specified for new entries. Otherwise should be only set if the intend it to change it.',
  },
  order: { type: 'number', description: 'Optional, Describes the order in the list.' },
};
